import AjaxLoad from '../utilities/js/ajax-load';
import { createElementFromHTML, tryParseJSON } from '../utilities/js/helper.js';

class Loader {
    constructor ($loader, options) {
        const defaults = {
            initAttr: 'data-loader',
            handleAttr: 'data-loader-handle',
            loading: null,
            onLoaded: null,
            external: false,
            onSubmitted: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$loader = $loader;
        this.$handle = $loader.querySelector('[' + this.settings.handleAttr + ']');
        this.$parent = $loader.parentNode;
        this.$sendFormData = false;
        this.formId = null;
    }

    initialize () {
        if (this.$loader.getAttribute(this.settings.initAttr) !== '') {
            this.formId = this.$loader.getAttribute(this.settings.initAttr).split('#')[1];
        }

        this.$sendFormData = document.getElementById(this.formId);

        this.$handle.addEventListener('click', (e) => {
            let formData = null;
            let formMethod = 'GET';
            const uri = this.$handle.getAttribute('href');

            if (this.settings.loading !== null) {
                this.$loader.appendChild(createElementFromHTML(this.settings.loading));
            }

            if (this.$sendFormData) {
                formMethod = this.$sendFormData.getAttribute('method');
                formData = new FormData(this.$sendFormData);
            }

            new AjaxLoad(uri, { // eslint-disable-line
                requestMethod: formMethod,
                requestData: formData,
                onSuccess: (resultText) => {
                    this.$loader.querySelector('.loading').remove();
                    const parseResult = tryParseJSON(resultText);

                    if (this.settings.external === true) {
                        if (typeof this.settings.onSubmitted === 'function') {
                            this.settings.onSubmitted(resultText);
                        }
                    } else {
                        if (parseResult && Object.keys(parseResult).length > 0) {
                            if (typeof parseResult === 'object' && typeof parseResult.nextPageUrl !== 'undefined' && typeof parseResult.template !== 'undefined') {
                                const nextPageUrl = parseResult.nextPageUrl;
                                const $newItems = createElementFromHTML(parseResult.template);

                                if (nextPageUrl !== null) {
                                    this.$handle.setAttribute('href', nextPageUrl);
                                } else {
                                    this.$loader.classList.add('is--hidden');
                                }

                                if ($newItems.length > 1) {
                                    const $newContent = document.createElement('div');
                                    $newItems.forEach(item => {
                                        $newContent.appendChild(item);
                                    });

                                    this.settings.onSubmitted($newContent);
                                    $newItems.forEach(item => {
                                        this.$loader.parentNode.insertBefore(item, this.$loader);
                                    });
                                } else {
                                    this.$loader.parentNode.appendChild($newItems);

                                    if (typeof this.settings.onSubmitted === 'function') {
                                        this.settings.onSubmitted($newItems);
                                    }
                                }
                            }
                        } else {
                            const $result = createElementFromHTML(resultText);
                            const $newLoader = $result.children;

                            if (typeof this.settings.onSubmitted === 'function') {
                                this.settings.onSubmitted($result);
                            }

                            Array.from($newLoader).forEach(($child) => {
                                this.$loader.parentNode.appendChild($child);
                            });

                            this.$loader.remove();
                        }
                    }
                }
            });

            e.preventDefault();
        });
    }
}

export { Loader };
